import HomePage from "./Pages/HomePage/HomePage";

const App = () => {
  return (
    <>
      <title>Adam and Laura's Wedding</title>
      <HomePage />
    </>
  );
};

export default App;
